import { dew as _getChainContractAddressDew } from "../../utils/chain/getChainContractAddress.js";
import { dew as _toHexDew } from "../../utils/encoding/toHex.js";
import { dew as _packetToBytesDew } from "../../utils/ens/packetToBytes.js";
import { dew as _getActionDew } from "../../utils/getAction.js";
import { dew as _readContractDew } from "../public/readContract.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getEnsResolver = void 0;
  const getChainContractAddress_js_1 = _getChainContractAddressDew();
  const toHex_js_1 = _toHexDew();
  const packetToBytes_js_1 = _packetToBytesDew();
  const getAction_js_1 = _getActionDew();
  const readContract_js_1 = _readContractDew();
  async function getEnsResolver(client, {
    blockNumber,
    blockTag,
    name,
    universalResolverAddress: universalResolverAddress_
  }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
      if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
      universalResolverAddress = (0, getChainContractAddress_js_1.getChainContractAddress)({
        blockNumber,
        chain: client.chain,
        contract: "ensUniversalResolver"
      });
    }
    const [resolverAddress] = await (0, getAction_js_1.getAction)(client, readContract_js_1.readContract, "readContract")({
      address: universalResolverAddress,
      abi: [{
        inputs: [{
          type: "bytes"
        }],
        name: "findResolver",
        outputs: [{
          type: "address"
        }, {
          type: "bytes32"
        }],
        stateMutability: "view",
        type: "function"
      }],
      functionName: "findResolver",
      args: [(0, toHex_js_1.toHex)((0, packetToBytes_js_1.packetToBytes)(name))],
      blockNumber,
      blockTag
    });
    return resolverAddress;
  }
  exports.getEnsResolver = getEnsResolver;
  //# sourceMappingURL=getEnsResolver.js.map
  return exports;
}